<script>
export default {
  name: "CompanyFormatter",
  functional: true,

  render(createElement, context) {
    let { rowValue } = context.data.attrs;
    let { column } = context.data.attrs;

    let clase = String;
    let rol = String;

    if (column == "companyCode") {
      switch (rowValue) {
        case "TB":
          clase = "blue";
          rol = "Tennos Business";
          break;
        case "MTR":
          clase = "green";
          rol = "MagyTrack";
          break;
      }
    } else if (column == "UserRole") {
      switch (rowValue) {
        case "Admin":
          rol = "Administrador";
          break;
        case "Basico":
          rol = rowValue;
          break;
        case "Financiero":
          rol = rowValue;
          break;
        case "Tecnico":
          rol = rowValue;
          break;
        case null:
          rol = "Sin Rol";
          break;
      }
    }

    return createElement(
      "b",
      {
        attrs: {
          name: "",
          class: clase
        }
      },
      rol
    );
  }
};
</script>

<style scoped>
.blue {
  color: #449ad3;
}
.green {
  color: #3ed0c1;
}
</style>
